import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import {
  AmCropGrowthLegendDetails,
  AmSoilMoistureLegendDetails,
} from "./const";

const AmSatelliteImageryLegend = ({ activeTile }) => {
  if (activeTile === "none") return null;

  const title = activeTile === "ndvi" ? "Crop Health" : "Soil Moisture";

  const legendItems =
    activeTile === "ndvi"
      ? AmCropGrowthLegendDetails
      : AmSoilMoistureLegendDetails;

  return (
    <Box
      sx={{
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        padding: "10px",
      }}
    >
      <Typography variant="caption" fontWeight="bold" display="block" mb={1}>
        {title}
      </Typography>
      {legendItems.map((item) => (
        <Tooltip key={item.range} title={item.description} placement="left">
          <Box sx={{ display: "flex", alignItems: "center", mb: 0.5, gap: 1 }}>
            <Box
              sx={{
                height: "20px",
                width: "100px",
                background: `linear-gradient(to right, ${item.minColor}, ${item.maxColor})`,
                borderRadius: "2px",
                mb: 0.5,
                border: "1px solid red",
              }}
            />
            <Typography variant="caption">
              {item.label} ({item.description})
            </Typography>
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

export default AmSatelliteImageryLegend;

AmSatelliteImageryLegend.propTypes = {
  activeTile: PropTypes.string.isRequired,
};
